import { createContext } from 'react';

export type AccountingSystemCtx = {
  showInsufficientFunds: boolean;
  showError: boolean;
  errorMessage: string;
  clientName: string;
  showCancel: boolean;
  showScheduleAll: boolean;
  showScheduleCustomDate: boolean;
  showNoPaymentMethod: boolean;
  showCancelSchedule: boolean;
  hasItemsWithNoPaymentMethod: boolean;
  type: 'Payable' | 'Receivable';
};

const AccountingSystemContext = createContext<AccountingSystemCtx>({
  showInsufficientFunds: false,
  showError: false,
  showCancel: false,
  showNoPaymentMethod: false,
  showCancelSchedule: false,
  showScheduleAll: false,
  showScheduleCustomDate: false,
  hasItemsWithNoPaymentMethod: false,
  type: 'Payable',
  errorMessage: '',
  clientName: '',
});

export default AccountingSystemContext;
